import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./App.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import Amplify from "aws-amplify";
import devConfig from "./aws-config-dev/aws-exports";
import prodConfig from "./aws-config-prod/aws-exports";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

let amplifyConfiguration = process.env.REACT_APP_ENV === "production" ? prodConfig : devConfig;
// let amplifyConfiguration = prodConfig;

Amplify.configure(amplifyConfiguration);
const theme = createMuiTheme({
  typography: { useNextVariants: true },
  palette: {
    primary: {
      main: "#51A882",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#EB6D80",
      contrastText: "#ffffff"
    },
    text: {
      primary: "rgba(0, 0, 0, 0.65)"
    }
  },
  overrides: {
    MuiButton: {
      label: {
        textTransform: "none"
      }
    }
  }
});

const Application = (
  <MuiThemeProvider theme={theme}>
    <App />
  </MuiThemeProvider>
);

ReactDOM.render(Application, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();

window.deferredPrompt = null;
window.promptInstall = null;

window.addEventListener("beforeinstallprompt", e => {
  // Stash the event so it can be triggered later.
  e.preventDefault();
  // deferredPrompt = e;
  console.log("beforeinstallprompt");
  window.deferredPrompt = e;
  window.promptInstall = true;
  // Create our shared stylesheet:
  let stylesheet = document.styleSheets[0];
  stylesheet.cssRules[0].style.display = "block";
});

window.onClickInstall = e => {
  e.preventDefault();
  // console.log("clicked install")
  window.deferredPrompt.prompt();
  // Wait for the user to respond to the prompt
  window.deferredPrompt.userChoice.then(choiceResult => {
    if (choiceResult.outcome === "accepted") {
      let stylesheet = document.styleSheets[0];
      stylesheet.cssRules[0].style.display = "none";
    } else {
      // console.log("User dismissed the A2HS prompt");
    }
    window.deferredPrompt = null;
  });
};
